import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { AKBetsCompliancePopupLogo } from 'src/assets/logos/compliancePopup/AKBetsCompliancePopupLogo';
import { AKBetsLogo } from 'src/assets/logos/AKBetsLogo';
import { AKBetsBrandIcon } from 'src/assets/brandIcons/AKBetsBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const AKBetsMainLogoWrapper = withConfig(theme => styled('div', { label: 'AKBetsMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const AKBetsMainLogo = styled(AKBetsLogo, { label: 'AKBetsMainLogo' })`
    height: 24px;
    margin: 0 auto;
    width: 95px;
`;

export const AKBetsBrandIconWrapper = styled(AKBetsBrandIcon, { label: 'AKBetsBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 32px;
    margin: 0 auto;
    width: 32px;
`;

export const CompliancePopupLogo = styled(AKBetsCompliancePopupLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
